import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { Typography } from "@vc-workspace/utils-typography";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { TailwindColors } from "@vc-workspace/utils-colors";
import StarIcon from '@mui/icons-material/Star';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Link from "next/link";
import { getFormattedNumber } from "@vc-workspace/utils-formatters";

var ShopLocationReviewWidget = function ShopLocationReviewWidget(props) {
  var onSeeAllReviews = function onSeeAllReviews() {// TODO
  };

  return _jsxs("div", {
    className: "flex items-center pt-3 md:pt-0",
    children: [_jsxs(Typography, {
      type: props.context.isMobileView ? "Body2" : "SubHeading1",
      color: TailwindColors.grey[500],
      className: "flex items-center",
      semi_bold: true,
      children: [!props.context.isMobileView && props.shop.warehouseCityCountry ? _jsx(LocationOnOutlinedIcon, {
        fontSize: "small"
      }) : null, props.shop.warehouseCityCountry, " \xA0"]
    }), props.shop.averageRating ? _jsxs(_Fragment, {
      children: [_jsx(Typography, {
        type: "Body1",
        color: TailwindColors.grey[400],
        className: props.context.isMobileView ? "px-1" : "px-3",
        children: "\u2022"
      }), _jsx(Typography, {
        type: "Caption",
        color: TailwindColors.amber[500],
        className: "pr-px",
        children: _jsx(StarIcon, {
          fontSize: "small"
        })
      }), _jsx(Typography, {
        type: props.context.isMobileView ? "Body2" : "SubHeading1",
        color: TailwindColors.grey[800],
        semi_bold: true,
        children: props.shop.averageRating
      }), _jsx(Typography, {
        type: props.context.isMobileView ? "Body2" : "Body1",
        color: TailwindColors.grey[400],
        className: props.context.isMobileView ? "px-1" : "px-3",
        children: "\u2022"
      }), _jsxs(Typography, {
        type: props.context.isMobileView ? "Body2" : "Body1",
        color: TailwindColors.grey[600],
        underline: !props.context.isMobileView,
        children: [getFormattedNumber(props.shop.totalRatings), " ratings"]
      }), props.shop.totalReviewsCount ? _jsxs(_Fragment, {
        children: [_jsx(Typography, {
          type: props.context.isMobileView ? "Body2" : "Body1",
          color: TailwindColors.grey[400],
          className: props.context.isMobileView ? "px-1" : "px-3",
          children: "\u2022"
        }), _jsx(Link, {
          href: "/".concat(props.shop.slug, "/reviews"),
          passHref: true,
          children: _jsx("a", {
            children: _jsxs(Typography, {
              type: props.context.isMobileView ? "Body2" : "SubHeading1",
              color: TailwindColors.purple[800],
              className: "flex items-center cursor-pointer",
              onClick: onSeeAllReviews,
              children: ["See reviews ", _jsx(ChevronRightIcon, {
                fontSize: "small"
              })]
            })
          })
        })]
      }) : null]
    }) : null]
  });
};

export default ShopLocationReviewWidget;